import React from 'react';
import PropTypes from 'prop-types';
import { getLiftClass, getLiftColor } from "../../helpers/map";
import LiftLine from "./components/LiftLine";

const Lift7R = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift7R"
			 className={getLiftClass(isOpen, activeLiftId === '7R', state)}
			 transform="translate(1584.438783, 1227.686672) rotate(76.000000) translate(-1584.438783, -1227.686672) translate(1565.438783, 1167.686672)"
		>
			<LiftLine x1="21.5" y1="15.5050737" x2="14.3111031" y2="105.5289" color={colors[0]}/>

			<g id="Labe-lift"
				 transform="translate(21.244530, 16.152809) rotate(-75.000000) translate(-21.244530, -16.152809) translate(8.244530, 3.152809)">
				<circle fill={colors[1]} fillRule="evenodd" cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" fillRule="evenodd" cx="13" cy="13" r="10"/>
				<text fontFamily="OpenSans-Bold, Open Sans" fontSize="12" fontWeight="bold" fill={colors[2]}>
					<tspan x="5.11425781" y="17">7R</tspan>
				</text>
			</g>

			<g id="Labe-lift" transform="translate(0.598885, 93.762348)" className="lift-label">
				<circle fill={colors[1]} fillRule="evenodd" cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" fillRule="evenodd" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(14.311103, 105.528900) scale(-1, 1) rotate(-276.000000) translate(-14.311103, -105.528900) "
				points="8.81110308 105.5289 19.8111031 100.0289 17.4396158 105.5289 19.8111031 111.0289"/>
		</g>
	);
};

Lift7R.propTypes = {
	isOpen: PropTypes.bool,
	activeLiftId: PropTypes.string
};

export default Lift7R;
